const CardContent = ({ children, ...props }) => {
  return <div {...props}>{children}</div>;
};

export default CardContent;
